import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Pages
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import SuperAdminDashboard from '@/pages/SuperAdminDashboard';
import CompanyDashboard from '@/pages/CompanyDashboard';
import CompanySettings from '@/pages/CompanySettings';
import DebtorSearch from '@/pages/DebtorSearch';
import DebtorDashboard from '@/pages/DebtorDashboard';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentFailure from '@/pages/PaymentFailure';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsConditions from '@/pages/TermsConditions';
import Presentacion from '@/pages/Presentacion';
import AuthCallback from '@/components/AuthCallback';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id during render (not in useEffect)
  // This prevents race conditions with auth checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/superadmin" element={<SuperAdminDashboard />} />
      <Route path="/dashboard" element={<CompanyDashboard />} />
      <Route path="/dashboard/settings" element={<CompanySettings />} />
      <Route path="/debtor/search" element={<DebtorSearch />} />
      <Route path="/debtor/:token" element={<DebtorDashboard />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failure" element={<PaymentFailure />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/presentacion" element={<Presentacion />} />
      
      {/* Rutas personalizadas por empresa */}
      <Route path="/t/:slug/:token" element={<DebtorDashboard />} />
      <Route path="/t/:slug" element={<DebtorSearch />} />
      <Route path="/:slug" element={<DebtorSearch />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;